import React from "react";
import Login from "../pages/Login/login";
import Dashboard from "../pages/Dashboard/dashboard";

import User from "../pages/user/user";
import AddUser from "../pages/user/addUser";
import VehicleList from "../pages/Vehicle/vehicleList";
import VehicleGroup from "../pages/Vehicle/vehicleGroup";
import DriverList from "../pages/Driver/driverList";
import BookingList from "../pages/Booking/bookingList";
import CustomerList from "../pages/Customer/customerList";
import MaintenanceList from "../pages/Maintenance/maintenanceList";
import PartInventoryList from "../pages/Parts-Inventory/partInventoryList";
import FuelList from "../pages/Fuel/fuelList";
import AddVehicle from "../pages/Vehicle/addVehicle";
import ReminderList from "../pages/Reminder/reminderList";
import IncomeAndExpensesList from "../pages/Income&Expenses/incomeAndExpensesList";
import AddCustomer from "../pages/Customer/add.Customer";
import AddBooking from "../pages/Booking/add-Booking";
import Addriver from "../pages/Driver/add-driver";
import Maintenanceadd from "../pages/Maintenance/add-Maintenance";
import Addpartinventory from "../pages/Parts-Inventory/add-partinventory";
import Addfuel from "../pages/Fuel/add-fuel";
import Addreminder from "../pages/Reminder/add-reminder";
import Addincome from "../pages/Income&Expenses/add-income";
import Generalsetting from "../pages/setting/general-setting";
import SMPTconfiguration from "../pages/setting/SMPT-configuration";
import RoleList from "../pages/Roles/RoleList";
import Addrole from "../pages/Roles/Addrole";
import Traccerconfig from "../pages/setting/traccer-config-temp";
import Changepassword from "../pages/change-password/change-password";
import Viewvehicle from "../pages/Vehicle/viewvehicle";
import ViewDetail from "../pages/Booking/view-Detail";
import Companylist from "../pages/companies/CompaniesListing";
import AddnewCompany from "../pages/companies/AddnewCompanies";
import DraggableTable from "../components/ComponentCustomerDnd";
// import MapWithAutocomplete from "../components/MapWithAutocomplete";
import Viewcomanydetail from "../pages/companies/Viewcomanydetail";
import Signup from "../pages/Signup/signup";
import AdminLiveTrackingMap from "../components/PassengerMap";
import PrivacyPolicy from "../pages/PrivacyPolicy/PrivacyPolicy";
import PrivacyPolicyTwo from "../pages/PrivacyPolicyTwo/PrivacyPolicyTwo";
import CreateTenant from "../pages/Tenant/CreateTenant";
import TenantList from "../pages/Tenant/TenantList";
// import PrivacyPolicy from "../pages/PrivacyPolicy/PrivacyPolicy";
// import MapWithAutocomplete from "../components/MapWithAutocomplete";

export const authProtectedRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  {path:"/viewcomanydetail/:id",component:<Viewcomanydetail/>},
  { path: "/user-list", component: <User /> },
  { path: "/vehicle-list", component: <VehicleList /> },
  { path: "/role-list", component: <RoleList /> },
  { path: "/vehicle-group-list", component: <VehicleGroup /> },
  { path: "/school-listing", component: <Companylist /> },
  { path: "/company-listing", component: <Companylist /> },
  { path: "/add-new-school", component: <AddnewCompany /> },
  { path: "/add-new-company", component: <AddnewCompany /> },
  { path: "/edit-new-school/:id", component: <AddnewCompany /> },
  { path: "/edit-new-company/:id", component: <AddnewCompany /> },
  { path: "/driver-list", component: <DriverList /> },
  { path: "/booking-list", component: <BookingList /> },
  { path: "/parent-list", component: <CustomerList /> },
  { path: "/editUser/:id", component: <AddUser /> },
  { path: "/edit-parent/:id", component: <AddCustomer /> },
  { path: "/maintenance-list", component: <MaintenanceList /> },
  { path: "/part-inventory-list", component: <PartInventoryList /> },
  { path: "/fuel-list", component: <FuelList /> },
  { path: "/reminder-list", component: <ReminderList /> },
  { path: "/income-and-expenses-list", component: <IncomeAndExpensesList /> },

  { path: "/add-vehicle", component: <AddVehicle /> },
  { path: "/add-role", component: <Addrole /> },
  { path: "/edit-role/:id", component: <Addrole /> },
  { path: "/edit-vehicle/:id", component: <AddVehicle /> },

  { path: "/view-Detail/:id", component: <ViewDetail /> },

  { path: "/SMPT-configuration", component: <SMPTconfiguration /> },

  { path: "/general-setting", component: <Generalsetting /> },

  { path: "/addUser", component: <AddUser /> },

  { path: "/change-password", component: <Changepassword /> },

  { path: "/view-vehicle/:id", component: <Viewvehicle /> },

  { path: "/add-income", component: <Addincome /> },
  { path: "/edit-income/:id", component: <Addincome /> },
  { path: "/traccer-config", component: <Traccerconfig /> },

  { path: "/add-reminder", component: <Addreminder /> },
  { path: "/edit-reminder/:id", component: <Addreminder /> },

  { path: "/add-partinventory", component: <Addpartinventory /> },
  { path: "/edit-partinventory/:id", component: <Addpartinventory /> },

  { path: "/add-driver", component: <Addriver /> },
  { path: "/edit-driver/:id", component: <Addriver /> },
  { path: "/add-fuel", component: <Addfuel /> },

  { path: "/add-parent", component: <AddCustomer /> },
  { path: "/add-maintenance", component: <Maintenanceadd /> },
  { path: "/edit-maintenance/:id", component: <Maintenanceadd /> },
  { path: "/add-booking", component: <AddBooking /> },
  { path: "/edit-booking/:id", component: <AddBooking /> },
  { path: "/Drage", component: <DraggableTable /> },
  { path: "/all-van", component: <AdminLiveTrackingMap /> },
  { path: "/tenant-list", component: <TenantList /> },
  { path: "/create-tenant", component: <CreateTenant /> },
  { path: "/edit-tenant/:id", component: <CreateTenant /> },
  
];
export const DefaultRoutes = [{ path: "/login", component: <Login /> }, ];
export const publicRoutes = [ { path: "/login", component: <Login /> }, { path: "/signup", component: <Signup /> },{ path:"/privacypolicy", component: <PrivacyPolicy/>},{ path:"/parentPrivacypolicy", component: <PrivacyPolicyTwo/>}];
